import React from "react";
import TextMenuPage from "../components/TextMenuPage";
import drinksSections from "../data/drinks_sections.json";
import { useI18n } from "../data/i18n";

const DrinksMenu = () => {
  const { t, lang } = useI18n(); // ВЗЕМЕТЕ И lang
  
  // ВЗЕМЕТЕ ПРАВИЛНИЯ МАСИВ СПОРЕД ЕЗИКА
  const sections = drinksSections[lang] || drinksSections.bg;
  
  // ПРОВЕРКА ДАЛИ Е МАСИВ
  
  return (
    <TextMenuPage
      label={t("menu.drinks")}
      title={t("menu.drinks")}
      sections={sections}
    />
  );
};

export default DrinksMenu;